import { LOADING_SHOW } from './types';


export function loading(state) {
    return {
        type: LOADING_SHOW,
        payload: state
    }
}